export const queryKeys = {
    me: ['me'] as const,
    family: (familyId: string) => ['family', familyId] as const,
    members: (familyId: string) => ['members', familyId] as const,
    invitations: (familyId: string) => ['invitations', familyId] as const,
    children: (familyId: string, includeArchived: boolean) =>
        ['children', familyId, includeArchived] as const,
    summary: (familyId: string, date: string) => ['summary', familyId, date] as const,
    days: (familyId: string, from: string, to: string) => ['days', familyId, from, to] as const,
    timeline: (familyId: string, from: string, to: string, childId: string, type: string) =>
        ['timeline', familyId, from, to, childId, type] as const,
    insights: (familyId: string, childId: string, days: number) =>
        ['insights', familyId, childId, days] as const,
    growth: (familyId: string, childId: string) => ['growth', familyId, childId] as const,
    milestones: (familyId: string, childId: string) => ['milestones', familyId, childId] as const,
    medications: (familyId: string, childId: string) => ['medications', familyId, childId] as const,
    doses: (familyId: string, childId: string) => ['doses', familyId, childId] as const,
    reminders: (familyId: string, childId: string) => ['reminders', familyId, childId] as const,
    photos: (familyId: string, childId: string) => ['photos', familyId, childId] as const,
    notifications: (familyId: string) => ['notifications', familyId] as const,
};
